import { Link } from "react-router-dom";
import { LogOut, GraduationCap, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Reveal } from "@/components/Motion";
import { COURSES } from "@/data/content";

export default function AreaStudente() {
  const { user, logout } = useAuth();
  const main = COURSES.filter((c) => c.track === "principale");

  return (
    <div className="pt-32 pb-28 min-h-screen constellation">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="flex items-start justify-between flex-wrap gap-6">
            <div>
              <p className="text-xs uppercase tracking-[0.25em] text-gold mb-4">Area Studente</p>
              <h1 className="font-display text-4xl sm:text-5xl text-[#2A1F14]">Benvenuto, {user?.name?.split(" ")[0] || "Studente"}.</h1>
              <p className="text-[#2A1F14]/50 mt-3">{user?.email}</p>
            </div>
            <button onClick={logout} data-testid="logout-btn" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#2A1F14]/15 text-[#2A1F14]/70 hover:border-gold hover:text-gold transition-colors text-sm">
              <LogOut size={16} /> Esci
            </button>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="glass rounded-2xl p-10 mt-14 text-center">
            <GraduationCap className="text-gold mx-auto mb-6" size={40} />
            <h2 className="font-display text-2xl text-[#2A1F14] mb-3">Il tuo percorso in LUX ACADEMY</h2>
            <p className="text-[#2A1F14]/50 max-w-xl mx-auto leading-relaxed">Qui troverai i tuoi corsi, i materiali didattici e gli attestati. Esplora il catalogo e inizia il tuo cammino akashico.</p>
            <Link to="/academy" className="inline-flex items-center gap-2 mt-8 px-8 py-4 rounded-full bg-gold text-black text-sm font-medium hover:bg-[#D4A056] transition-colors">Vai al catalogo <ArrowRight size={16} /></Link>
          </div>
        </Reveal>

        <div className="mt-16">
          <h3 className="font-display text-2xl text-[#2A1F14] mb-8">Percorsi consigliati per te</h3>
          <div className="grid md:grid-cols-3 gap-4">
            {main.map((c) => (
              <Link key={c.slug} to={`/academy/${c.slug}`} className="border border-[#2A1F14]/10 rounded-xl p-7 hover:border-gold/40 transition-colors duration-500 group">
                <p className="text-[10px] uppercase tracking-[0.2em] text-gold mb-3">{c.level}</p>
                <h4 className="font-display text-xl text-[#2A1F14] mb-2 group-hover:text-gold transition-colors">{c.title}</h4>
                <p className="text-[#2A1F14]/40 text-sm">{c.duration}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
